import { Type } from 'class-transformer';
import { IsBoolean, IsObject, IsOptional, ValidateNested } from 'class-validator';
import { BaseDto } from '../../../../@base/base.dto';
import { OwnerProfileId, UserId } from '../../../../types';

export class OwnerNotificationSettingsDto {
  @IsBoolean()
  @IsOptional()
  emailAlertsEnabled?: boolean;

  @IsBoolean()
  @IsOptional()
  applicationAlertsEnabled?: boolean;
}

export class OwnerSettingsDto {
  @IsObject()
  @ValidateNested()
  @Type(() => OwnerNotificationSettingsDto)
  @IsOptional()
  notifications?: OwnerNotificationSettingsDto;
}

export class OwnerProfileDto extends BaseDto<OwnerProfileId> {
  user!: UserId;

  @IsObject()
  @ValidateNested()
  @Type(() => OwnerSettingsDto)
  @IsOptional()
  settings?: OwnerSettingsDto;
}
